module.exports = __webpack_public_path__ + "static/media/DSC_0173.b6adb52a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/scenery/DSC_0173.jpg
// module id = 693
// module chunks = 0